module.exports = __webpack_public_path__ + "img/mat_102.ceda21cf.png";